import React from "react";
import styled from "styled-components";
import { usePhotos } from "../../Hooks/usePhotos";
import { useNavigate } from "react-router-dom";

const PhotoManager = () => {
  const navigate = useNavigate();
  const { posts, loading, error, deletePost } = usePhotos();
  const handleEdit = (post) => {
    navigate(`/Admin/Dashboard/edit/${post.id}`, { state: { post } });
  };

  const handleUpload = () => alert("새로운 게시물 등록 페이지로 이동합니다.");

  const handleDelete = async (id) => {
    if (window.confirm("해당 게시물을 삭제하시겠습니까?")) {
      await deletePost(id);
    }
  };

  if (loading) return <StatusMsg>데이터를 불러오는 중입니다...</StatusMsg>;
  if (error && posts.length === 0)
    return <StatusMsg>에러가 발생했습니다: {error}</StatusMsg>;

  return (
    <Container>
      <HeaderRow>
        <Description>
          <h2>홈페이지 콘텐츠 관리</h2>
          <p>총 {posts.length}개의 게시물이 등록되어 있습니다.</p>
        </Description>
        <UploadBtn onClick={handleUpload}>+ 새 콘텐츠 등록</UploadBtn>
      </HeaderRow>

      <PostGrid>
        {posts.map((post) => (
          <PostCard key={post.id}>
            <ThumbnailWrapper>
              <img
                src={`${process.env.REACT_APP_BACK_API_URL}/company/${post.imgUrl}`}
                alt={post.title}
              />
              <PhotoBadge>{JSON.parse(post.gallery).length + 1}장</PhotoBadge>
            </ThumbnailWrapper>

            <PostInfo>
              <PostTitle>{post.title}</PostTitle>
              <div
                style={{ fontSize: "0.7em", color: "gray", margin: "10px 0px" }}
              >
                {post.desc}
              </div>
              <PostMeta>
                <span className="date">등록일: {post.date}</span>
                <div className="actions">
                  <ActionButton onClick={() => handleEdit(post)}>
                    수정
                  </ActionButton>
                  <ActionButton
                    className="delete"
                    onClick={() => handleDelete(post.id)}
                  >
                    삭제
                  </ActionButton>
                </div>
              </PostMeta>
            </PostInfo>
          </PostCard>
        ))}
      </PostGrid>
    </Container>
  );
};

// --- Styled Components (유님의 Sophisticated 스타일 반영) ---

const StatusMsg = styled.div`
  display: flex;
  justify-content: center;
  padding: 5rem;
  color: #64748b;
  font-weight: 600;
`;

const Container = styled.section`
  animation: fadeIn 0.5s ease;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2.5rem;
  border-bottom: 2px solid #f1f5f9;
  padding-bottom: 1.5rem;
`;

const Description = styled.div`
  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 0.9rem;
    color: #64748b;
  }
`;

const UploadBtn = styled.button`
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #1d4ed8;
    transform: translateY(-2px);
  }
`;

const PostGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
`;

const PostCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  transition:
    transform 0.3s,
    box-shadow 0.3s;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  }
`;

const ThumbnailWrapper = styled.div`
  position: relative;
  height: 180px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PhotoBadge = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(15, 23, 42, 0.75);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  backdrop-filter: blur(4px);
`;

const PostInfo = styled.div`
  padding: 1.25rem;
`;

const PostTitle = styled.h3`
  font-size: 1.05rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PostMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .date {
    font-size: 0.8rem;
    color: #94a3b8;
  }
  .actions {
    display: flex;
    gap: 0.75rem;
  }
`;

const ActionButton = styled.button`
  border: none;
  background: none;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #2563eb;
  }
  &.delete:hover {
    color: #ef4444;
  }
`;

export default PhotoManager;
